export interface Volunteer {
  id: string;
  name: string;
  department: string;
  image: string;
  bio: string[];
  linkedin?: string;
}

export const volunteers: Volunteer[] = [
  {
    id: 'vol-1',
    name: 'Aakash Totlani',
    department: 'Logistics',
    image: '/images/Volunteers/Aakash.jpeg',
    bio: [
      'Managed logistics for multiple events.',
      'Ensured smooth transportation and setup.'
    ],
    linkedin: 'https://www.linkedin.com/in/aakashtotlani/'
  },
  {
    id: 'vol-2',
    name: 'Abhishek Thulasi',
    department: 'Hospitality',
    image: '/images/Volunteers/Abhishek2.png',
    bio: [
      'Led the hospitality team for 2024 events.',
      'Coordinated with vendors and guests.'
    ],
    linkedin: 'https://www.linkedin.com/in/abhishek-thulasi-860656258/'
  },
  {
    id: 'vol-3',
    name: 'Abdul Rahaman Shaik',
    department: 'Technical',
    image: '/images/Volunteers/Abdul.jpg',
    bio: [
      'Handled technical setup and troubleshooting.',
      'Supported speakers with AV needs.'
    ],
    linkedin: 'https://www.linkedin.com/in/abdul-rahman-420774249/'
  },
  {
    id: 'vol-4',
    name: 'Adarsh Raj',
    department: 'Marketing',
    image: '/images/Volunteers/Adarsh.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/sneha-rao/'
  },
  {
    id: 'vol-5',
    name: 'Aniket Jangale',
    department: 'Marketing',
    image: '/images/Volunteers/Aniket.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/aniket-jangale-a10a7114b/'
  },
  {
    id: 'vol-6',
    name: 'Anarbasha B',
    department: 'Marketing',
    image: '/images/Volunteers/ansar.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/ansar-basha/'
  },
  {
    id: 'vol-7',
    name: 'Ashish Singhal',
    department: 'Marketing',
    image: '/images/Volunteers/Ashish.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/ashish-s-188119151/'
  },
  {
    id: 'vol-8',
    name: 'Bharat Ashok Naik',
    department: 'Marketing',
    image: '/images/Volunteers/bharat.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/bharatnaik/'
  },
  {
    id: 'vol-9',
    name: 'C Manjunath',
    department: 'Marketing',
    image: '/images/Volunteers/manjunath.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/sneha-rao/'
  },
  {
    id: 'vol-10',
    name: 'Dasari Saisri Abhiram',
    department: 'Marketing',
    image: '/images/Volunteers/dasari.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/dasari-saisri-abhiram/'
  },
  {
    id: 'vol-11',
    name: 'David Rajah Selvaraj',
    department: 'Marketing',
    image: '/images/Volunteers/david.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/davidrajah/'
  },
  {
    id: 'vol-11',
    name: 'Deepak Kumar',
    department: 'Marketing',
    image: '/images/Volunteers/deepak2.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/idkumar/'
  },
  {
    id: 'vol-11',
    name: 'Gowthami Kalaignanam',
    department: 'Marketing',
    image: '/images/Volunteers/gowthami.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/gowthamikalaignanam/'
  },
  {
    id: 'vol-11',
    name: 'Hasita Karanam',
    department: 'Marketing',
    image: '/images/Volunteers/hasita.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/hasita-karanam-72351b165/'
  },
  {
    id: 'vol-11',
    name: 'Hemananthan',
    department: 'Marketing',
    image: '/images/Volunteers/heman.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/hemananthan-shanmuganathan-58a45615/'
  },
  {
    id: 'vol-11',
    name: 'Hira Kholkar',
    department: 'Marketing',
    image: '/images/Volunteers/hira.webp',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/hira-k-ab5229221/'
  },
  {
    id: 'vol-11',
    name: 'Jayanth M R',
    department: 'Marketing',
    image: '/images/Volunteers/jay.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/jayanth-r-15397aa0/'
  },
  {
    id: 'vol-11',
    name: 'Kanishyam P',
    department: 'Marketing',
    image: '/images/Volunteers/sham.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/shyam-p-248579126/'
  },
  {
    id: 'vol-11',
    name: 'Krishnendu Chakraborty',
    department: 'Marketing',
    image: '/images/Volunteers/krish.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/krishnendu-chakraborty/'
  },
  {
    id: 'vol-11',
    name: 'Kiran Y',
    department: 'Marketing',
    image: '/images/Volunteers/kiran.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/kiran-kumar-reddy-y7893105625/'
  },
  {
    id: 'vol-11',
    name: 'Milind Gite',
    department: 'Marketing',
    image: '/images/Volunteers/milind2.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/milind-gite-b35990127/'
  },
  {
    id: 'vol-11',
    name: 'Mohammad Kaleem',
    department: 'Marketing',
    image: '/images/Volunteers/kaleem.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/kaleemmd9866/'
  },
  {
    id: 'vol-11',
    name: 'Neha Rananaware',
    department: 'Marketing',
    image: '/images/Volunteers/neha.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/neha-rananaware-b726b5178/'
  },
  {
    id: 'vol-11',
    name: 'Palani Chinnasamy',
    department: 'Marketing',
    image: '/images/Volunteers/palani.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/palanichinnasamy/'
  },
  {
    id: 'vol-11',
    name: 'Pawan Kumar Patel R',
    department: 'Marketing',
    image: '/images/Volunteers/pawan.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/pawan-kumar-patel-r-7445ba202/'
  },
  {
    id: 'vol-11',
    name: 'Prabhu N',
    department: 'Marketing',
    image: '/images/Volunteers/prabhu2.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/prabhu-n-1b888b149/'
  },
  {
    id: 'vol-11',
    name: 'Raghavi Maddisetty',
    department: 'Marketing',
    image: '/images/Volunteers/raghavi.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/raghavi-maddisetty-54952b173/'
  },
  {
    id: 'vol-11',
    name: 'Rajaprashanth Naidu',
    department: 'Marketing',
    image: '/images/Volunteers/naidu.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/rajaprashanth-naidu-548199123/'
  },
  {
    id: 'vol-11',
    name: 'Rajeshwari Jain',
    department: 'Marketing',
    image: '/images/Volunteers/Rajeshwari.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/rajeshwari-jain-96287a137/'
  },
  {
    id: 'vol-11',
    name: 'Ranjana Bramhane',
    department: 'Marketing',
    image: '/images/Volunteers/Ranjana.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/ranjana-bramhane/'
  },
  {
    id: 'vol-11',
    name: 'Ravi Bhaktharaj',
    department: 'Marketing',
    image: '/images/Volunteers/Ravi.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/ravi-bhaktharaj-14103b171/'
  },
  {
    id: 'vol-11',
    name: 'Rizwan Shaik',
    department: 'Marketing',
    image: '/images/Volunteers/Rizwan.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/rizwan-shaik/'
  },
  {
    id: 'vol-11',
    name: 'Sadhana Vijayakumar',
    department: 'Marketing',
    image: '/images/Volunteers/Sadhna.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/sadhana-vijayakumar-845319224/'
  },
  {
    id: 'vol-11',
    name: 'Shravani Umesh Nevagi',
    department: 'Marketing',
    image: '/images/Volunteers/ShravaniNevagi.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/shravani-nevagi-5b76a9223/'
  },
  {
    id: 'vol-11',
    name: 'Sonali Satsangi',
    department: 'Marketing',
    image: '/images/Volunteers/sonali.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/sonalisatsangi2207/'
  },
  {
    id: 'vol-11',
    name: 'SP Harshini',
    department: 'Marketing',
    image: '/images/Volunteers/SP2.PNG',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/harshini-s/'
  },
  {
    id: 'vol-11',
    name: 'Vaishnavi Sunil Lokhande',
    department: 'Marketing',
    image: '/images/Volunteers/Vaishnavi.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/vaishnavilokhande/'
  },
  {
    id: 'vol-11',
    name: 'Venkatramana Kapavari',
    department: 'Marketing',
    image: '/images/Volunteers/Venkatramana.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/venkatramanakapavari/'
  },
  {
    id: 'vol-11',
    name: 'Vighnesh Nayak',
    department: 'Marketing',
    image: '/images/Volunteers/Vignesh.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/vighnesh-nayak-279732125/'
  },
  {
    id: 'vol-11',
    name: 'Vijaylaxmi',
    department: 'Marketing',
    image: '/images/Volunteers/Vijaylaxmi.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/vijaylaxmi-mathpati-164b56218/'
  },
  {
    id: 'vol-11',
    name: 'Sanjana',
    department: 'Marketing',
    image: '/images/Volunteers/Sanjana.png',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/sanjana1805/'
  },
  {
    id: 'vol-11',
    name: 'Debasmita Barik',
    department: 'Marketing',
    image: '/images/Volunteers/Debasmita.jpg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/debasmita-barik/'
  },
  {
    id: 'vol-11',
    name: 'Somnath Sharma',
    department: 'Marketing',
    image: '/images/Volunteers/Somnath.jpeg',
    bio: [
      'Managed social media campaigns.',
      'Designed event posters and banners.'
    ],
    linkedin: 'https://www.linkedin.com/in/somnath1690/'
  },
];
